import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ShowControlUnitsService {
  private controlUnitSubject = new Subject<any>();
  controlUnitEvent$ = this.controlUnitSubject.asObservable();

  private hideResultSectionSubject = new Subject<any>();
  hideResultSectionEvent$ = this.hideResultSectionSubject.asObservable();

  emitControlUnitEvent() {
    this.controlUnitSubject.next(null);
  }

  emitHideResultSectionEvent(flag) {
      this.hideResultSectionSubject.next(flag);
    }
  }